export default "__VITE_ASSET__pwwwrCed__"